(function () {
  'use strict';
  var shopping = new WeakMap();
  function publicProducts(host) {
    if (shopping.has(host)) return shopping.get(host);
    var products = new Map();
    var element = host.querySelector('[data-fit-shopping-catalog]');
    try {
      var data = JSON.parse(element ? element.textContent : '[]');
      if (Array.isArray(data)) data.forEach(function (product) {
        if (product && /^[a-z0-9][a-z0-9-]*$/.test(product.handle || '') && /^\d+$/.test(product.id || '') && typeof product.title === 'string' && typeof product.url === 'string') products.set(product.handle, product);
      });
    } catch (error) { products.clear(); }
    shopping.set(host, products);
    return products;
  }
  function receiveProduct(event) {
    var data = event.data;
    if (event.origin !== 'null' || (event.ports && event.ports.length)) return;
    if (!data || typeof data !== 'object' || Array.isArray(data)) return;
    var keys = Reflect.ownKeys(data);
    if (keys.length !== 2 || !Object.prototype.hasOwnProperty.call(data, 'type') || !Object.prototype.hasOwnProperty.call(data, 'handle')) return;
    if (data.type !== 'fullstop:size-product' || typeof data.handle !== 'string') return;
    document.querySelectorAll('.fs-fit-host').forEach(function (host) {
      var frame = host.querySelector('iframe.fs-fit-host__frame[data-fit-isolation="opaque-origin"]');
      if (!frame || event.source !== frame.contentWindow) return;
      var product = publicProducts(host).get(data.handle);
      var productButton = host.querySelector('[data-fs-size-product]');
      var popup = host.querySelector('fs-size-product');
      if (!product || !productButton || !popup || typeof popup.open !== 'function') return;
      // The only outward context is the product the customer explicitly opened.
      // No size, measurements, match list or calculator state is read here.
      productButton.dataset.fsSizeProduct = product.id;
      productButton.dataset.productUrl = product.url;
      productButton.dataset.productTitle = product.title;
      productButton.dataset.productImage = typeof product.image === 'string' ? product.image : '';
      productButton.disabled = false;
      var title = host.querySelector('[data-fit-shopping-title]');
      var bar = host.querySelector('[data-fit-shopbar]');
      if (title) title.textContent = product.title;
      if (bar) bar.hidden = false;
      var dialog = popup.querySelector('dialog');
      if (dialog && !dialog.hasAttribute('data-fit-return-focus')) {
        dialog.setAttribute('data-fit-return-focus', '');
        dialog.addEventListener('close', function () {
          if (frame.isConnected) frame.focus({ preventScroll: true });
        });
      }
      popup.open(productButton);
    });
  }
  function check(event) {
    var frame = event.target;
    if (!frame || !frame.matches || !frame.matches('iframe.fs-fit-host__frame')) return;
    var host = frame.closest('.fs-fit-host');
    var status = host && host.querySelector('[data-fit-loading]');
    var failure = host && host.querySelector('[data-fit-failed]');
    try {
      var tokens = Array.from(frame.sandbox);
      if (tokens.length !== 1 || tokens[0] !== 'allow-scripts' || frame.contentDocument !== null) throw new Error('origin');
      frame.setAttribute('data-fit-isolation', 'opaque-origin');
      frame.hidden = false;
      if (status) status.hidden = true;
      publicProducts(host);
    } catch (error) {
      frame.remove();
      if (status) status.hidden = true;
      if (failure) failure.hidden = false;
    }
  }
  document.addEventListener('load', check, true);
  window.addEventListener('message', receiveProduct);
  function checkLoadedFrames() {
    document.querySelectorAll('iframe.fs-fit-host__frame').forEach(function (frame) { check({ target: frame }); });
  }
  if (document.readyState === 'complete') checkLoadedFrames();
  else window.addEventListener('load', checkLoadedFrames, { once: true });
}());
